// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageloader-module__pageLoaderRoot___D7y1z {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.pageloader-module__pageLoaderMain___w2RAJ {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageLoader/pageloader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".pageLoaderRoot {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\n\n.pageLoaderMain {\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageLoaderRoot": `pageloader-module__pageLoaderRoot___D7y1z`,
	"pageLoaderMain": `pageloader-module__pageLoaderMain___w2RAJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
